const bingVisitorIdKey = 'bing-visitor-id';

export async function getBingTrackingParameters() {
  if (!window) return {};

  const { mid, ti, msclkid } = window?.uetq?.beaconParams || {};
  const visitorId = getVisitorId();

  return {
    ...(ti ? { bing_tag_id: ti } : {}),
    ...(mid ? { bing_page_load_id: mid } : {}),
    ...(visitorId ? { bing_visitor_id: visitorId } : {}),
    ...(msclkid && msclkid !== 'N' ? { bing_click_id: msclkid } : {}),
  };
}

function getVisitorId() {
  return localStorage.getItem(bingVisitorIdKey);
}
